"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Column = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Slider_1 = require("../../components/Slider");
const { rem } = ui_common_components_1.utils;
const StyledColumnContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.XSmall)};
    gap: ${rem(theme.Spacing.Size.Small)};
  `}
`;
const StyledNumberColumnContainer = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;
const maxWidth = 90;
const StyledInputNumberWrapper = styled_components_1.default.div `
  max-width: ${rem(maxWidth)};
`;
const StyledOptionsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
function Column({ onUpdate, options, textWidth }) {
    var _a, _b;
    const [columns, setColumns] = (0, react_1.useState)(((_a = options.find((option) => option.name === 'columns')) === null || _a === void 0 ? void 0 : _a.value) || 1);
    const minColumnGap = (0, react_1.useMemo)(() => { var _a; return ((_a = options.find((option) => option.name === 'gap')) === null || _a === void 0 ? void 0 : _a.min) || 0; }, [options]);
    const maxColumnGap = (0, react_1.useMemo)(() => { var _a; return ((_a = options.find((option) => option.name === 'gap')) === null || _a === void 0 ? void 0 : _a.max) || 0; }, [options]);
    const [columnWidth, setColumnWidth] = (0, react_1.useState)(options.find((option) => option.name === 'width') || {});
    const [columnGap, setColumnGap] = (0, react_1.useState)(((_b = options.find((option) => option.name === 'gap')) === null || _b === void 0 ? void 0 : _b.value) || minColumnGap);
    const handleColumnChange = (0, react_1.useCallback)((action, data, key) => {
        switch (action) {
            case 'on_set-column-number': {
                setColumns(data);
                setColumnWidth((prev) => (Object.assign(Object.assign({}, prev), { min: Math.round((textWidth - (data - 1) * maxColumnGap) / data), max: Math.round((textWidth - (data - 1) * minColumnGap) / data), value: Math.round((textWidth - (data - 1) * minColumnGap) / data) })));
                setColumnGap(minColumnGap);
                break;
            }
            case 'on_set-column-width': {
                setColumnWidth((prev) => {
                    return Object.assign(Object.assign({}, prev), { value: data });
                });
                const newColumnGap = Math.round((textWidth - columns * data) / (columns - 1));
                setColumnGap(Math.min(maxColumnGap, Math.max(minColumnGap, newColumnGap)));
                break;
            }
            case 'on_set-column-gap': {
                setColumnGap(data);
                setColumnWidth((prev) => (Object.assign(Object.assign({}, prev), { value: Math.round((textWidth - (columns - 1) * data) / columns) })));
                break;
            }
        }
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({ action, data: { [key]: data } });
    }, [onUpdate, textWidth, columns, minColumnGap, maxColumnGap]);
    const { t } = (0, ui_common_translation_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(StyledColumnContainer, { children: options.map((option) => {
            if (option.type === 'input') {
                return ((0, jsx_runtime_1.jsxs)(StyledNumberColumnContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: t(option.titleKey) }), (0, jsx_runtime_1.jsx)(StyledInputNumberWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { type: "number", min: option.min, max: option.max, name: option.name, value: columns, size: 'Small', id: option.id, onChange: (columnNumber) => handleColumnChange(option.action, parseInt(columnNumber), option.name.toLowerCase()) }) })] }, option.name));
            }
            if (columns > 1) {
                if (option.type === 'divider') {
                    return (0, jsx_runtime_1.jsx)(ui_common_components_1.Divider, {}, option.id);
                }
                if (option.type === 'slider') {
                    return ((0, jsx_runtime_1.jsxs)(StyledOptionsContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: t(option.titleKey) }), (0, jsx_runtime_1.jsx)(Slider_1.Slider, { id: option.id, variant: option.variant === 'section' ? 'section' : 'default', value: option.name === 'width' ? columnWidth.value : columnGap, maxValue: option.name === 'width' ? columnWidth.max : option.max, minValue: option.name === 'width' ? columnWidth.min : option.min, onUpdate: (sliderValue) => handleColumnChange(option.action, sliderValue, option.name.toLowerCase()) })] }, option.name));
                }
            }
            return null;
        }) }));
}
exports.Column = Column;
//# sourceMappingURL=Column.js.map